"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DonationFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _utils = require("../../utils");

var _donationConfig = require("./donationConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var DonationDefinition = _flowRuntime["default"].tdz(function () {
  return _donationConfig.DonationDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("amountValue", _flowRuntime["default"].number()), _flowRuntime["default"].property("setDonationAmount", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("donation", _flowRuntime["default"].ref(DonationDefinition)), _flowRuntime["default"].property("giftaidValue", _flowRuntime["default"].string()), _flowRuntime["default"].property("queryParams", _flowRuntime["default"].object(), true)));

var DonationFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DonationFields, _React$Component);

  var _super = (0, _createSuper2["default"])(DonationFields);

  function DonationFields() {
    (0, _classCallCheck2["default"])(this, DonationFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  (0, _createClass2["default"])(DonationFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          queryParams = _this$props.queryParams,
          setDonationAmount = _this$props.setDonationAmount,
          key = _this$props.donation.key;

      if (queryParams && queryParams.donation_amount) {
        var donationAmountInPence = Math.round(Number(queryParams.donation_amount) * 100).toFixed(0);
        setDonationAmount(key, donationAmountInPence);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          amountValue = _this$props2.amountValue,
          giftaidValue = _this$props2.giftaidValue;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "amount-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        key: _donationConfig.amount.key,
        textfield: _donationConfig.amount
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement(_fields.Checkbox, {
        key: _donationConfig.giftAid.key,
        checkbox: _donationConfig.giftAid
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "giftaid-amount"
      }, "Your gift to Anthony Nolan: ", /*#__PURE__*/_react["default"].createElement("span", null, (0, _utils.giftAidAmount)(amountValue, giftaidValue)))));
    }
  }]);
  return DonationFields;
}(_react["default"].Component);

exports.DonationFields = DonationFields;
DonationFields.defaultProps = {
  queryParams: undefined
};
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var key = ownProps.donation.key;
  var amountValue = selector(state, "".concat(key, ".amount"));
  var giftaidValue = selector(state, "".concat(key, ".giftaid"));
  return {
    amountValue: amountValue,
    giftaidValue: giftaidValue
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDonationAmount: function setDonationAmount(key, donationAmountInPence) {
      return dispatch((0, _reduxForm.change)('form', "".concat(key, ".amount"), donationAmountInPence));
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DonationFields);

exports["default"] = _default;